export default __webpack_public_path__ + "static/media/curriculum.640364dc.svg";